/**
 * GetProducts / GetActiveProducts: productType is party kind (not insurance line).
 * 1 — physical person, 2 — legal entity (same as Documents/Quotas).
 */
export const PRODUCT_TYPE_PHYSICAL = 1;
export const PRODUCT_TYPE_LEGAL = 2;

function productTypeOf(row) {
  if (!row) return null;
  const raw = row.productType ?? row.ProductType;
  if (raw == null || raw === "") return null;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
}

/** @returns {'legal'|'individual'|null} */
export function productPartyKind(row) {
  const pt = productTypeOf(row);
  if (pt === PRODUCT_TYPE_LEGAL) return "legal";
  if (pt === PRODUCT_TYPE_PHYSICAL) return "individual";

  const t = row.partyType;
  if (t === "legal" || t === "individual") return t;

  if (row.isLegalEntity === true || row.isLegalEntity === 1) return "legal";
  if (row.isLegalEntity === false || row.isLegalEntity === 0) return "individual";
  return null;
}

export function isProductLegalEntity(row) {
  return productPartyKind(row) === "legal";
}
